import { TranslationKeys } from './types';

export const zh: TranslationKeys = {
  // Home
  'home.beautyProfiler': '美妆测评',
  'home.looksGallery': '妆容画廊',
  'home.fragranceProfiler': '香氛测评',

  // Landing pages
  'landing.beautyProfiler.subtitle': '揭示你的标志性',
  'landing.beautyProfiler.title': '魅力',
  'landing.beautyProfiler.description': '美妆测评',
  'landing.fragranceProfiler.subtitle': '找到你的',
  'landing.fragranceProfiler.title': '香氛',
  'landing.fragranceProfiler.description': '踏入你的自信魅力',
  'landing.start': '开始',

  // Loading
  'loading.text': '加载中',

  // Common actions
  'back': '返回',
  'continue': '继续',
  'discover': '探索',
  'viewLook': '查看妆容',
  'playVideo': '播放视频',
  'watchTutorial': '观看教程',
  'scrollProductsRight': '向右滑动查看更多产品',

  // Profiler
  'profiler.beautySubtitle': '你的 Christian Louboutin 魅力',

  // Beauty profiler results
  'results.beauty.stepInto': '踏入',
  'results.beauty.the': '',
  'results.beauty.allureALaLouboutin': '魅力 à la Louboutin',
  'results.beauty.favoriteFragrance': '你最爱的香氛',
  'results.beauty.moreScents': '更多展现你魅力的香氛...',
  'results.beauty.personalizedRitual': '你的专属 Christian Louboutin',
  'results.beauty.beautyRitual': '美妆仪式',
  'results.beauty.with': '搭配...',
  'results.beauty.lipsSignature': '你的魅力，你的唇部标识',

  // Fragrance profiler results
  'results.fragrance.favoriteFragranceIs': '你最爱的香氛是',
  'results.fragrance.createYourOwnStyle': '创造你的风格，混搭',
  'results.fragrance.addTouchOf': '再添一抹',
  'results.fragrance.opulence': '奢华',
  'results.fragrance.sensuality': '感性',
  'results.fragrance.mystery': '神秘',
  'results.fragrance.elegance': '优雅',
  'results.fragrance.youShouldAlsoLike': '你可能也会喜欢...',

  // Looks gallery
  'looksGallery.beautyServices': '美容服务',
  'looksGallery.yourGlamorousJourney': '你的魅力之旅',
  'looksGallery.galerieDesLooks': '妆容画廊',
  'looksGallery.revealYourBeauty': '以优雅展现你的美丽',
  'looksGallery.looksALaLouboutin': 'Louboutin 风格妆容',
  'looksGallery.christianLouboutin': 'Christian Louboutin',

  // Beauty services
  'beautyServices.christianLouboutin': 'Christian Louboutin',
  'beautyServices.title': '美容服务',
  'beautyServices.makeup': '彩妆',
  'beautyServices.fragrance': '香氛',
  'beautyServices.min': '分钟',

  // Error
  'error.somethingWentWrong': '出现了问题',
  'error.pleaseRefresh': '请刷新页面重试。',
};
